var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    _vm._b(
      {
        attrs: {
          disableClose: _vm.loadingSubmit,
          "max-width": "500px",
          persistent: "",
          loading: _vm.loadingTemplates,
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v("\n    " + _vm._s(_vm.appModalTitle) + "\n  ")]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c("StaticContentForm", {
                  ref: "form",
                  attrs: {
                    addForm: _vm.addForm,
                    value: _vm.value,
                    isValid: _vm.formIsValid,
                    "tenant-name": _vm.tenantName,
                  },
                  on: {
                    "update:isValid": function ($event) {
                      _vm.formIsValid = $event
                    },
                    "update:is-valid": function ($event) {
                      _vm.formIsValid = $event
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "success",
                      disabled: !_vm.formIsValid,
                      loading: _vm.loadingSubmit,
                    },
                    on: { click: _vm.submit },
                  },
                  [
                    _c("v-icon", { attrs: { left: "" } }, [_vm._v("done")]),
                    _vm._v("Save\n    "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { disabled: _vm.loadingSubmit },
                    on: { click: _vm.close },
                  },
                  [_vm._v("Cancel")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.dialog,
          callback: function ($$v) {
            _vm.dialog = $$v
          },
          expression: "dialog",
        },
      },
      "AppModal",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }